<!-- Sidepanel Right Search Customer -->
<aside [ngClass]="{'active':  userService.userCloneModal.isModalOpen }"
  class="footer-sidepanel footer-sidepanel--customer-search">
  <div class="footer-sidepanel__header">
    <h5><i class="fa-light fa-pen-to-square"></i>User Clone: {{ userService.userCloneModal.inputData.userName}} </h5>
    <a><i class="fa-light fa-xmark" (click)="closeModal()"></i></a>
  </div>
  <div class="footer-sidepanel__content">
    <div class="  form-wrapper-compact">
      <div class="flex-row">
        <div class="flex-col-sm-12"> 
          <section class="section form-wrapper-compact">
            <div class="section__content">
              <div class=" mb-10">
                <div class="address-form">
                  <form [formGroup]="userCloneForm" class="form-fields form-fields--tertiary form-container">
                    <div class="flex-row flex-row--compact">
                         <div class="flex-col-sm-6">
                        <!-- <label for="overflowid" class="form-fields__label">First Name<b style="color: red;">*</b></label> -->
                        <div class="single-input-field-wrapper clone-field">
                          <span [attr.data-tooltip]="getFieldError('FirstName')" data-tooltip-conf="danger"
                            class="important-input address-input form-fields__input-wrapper"
                            [ngClass]="{ 'hide': !checkUserFormFieldValidation('FirstName')}">
                            <input style="padding: 10px 5px 10px 10px;" type="text" formControlName="FirstName" id="FirstName" name="FirstName"
                              placeholder="FirstName" size="30" class="form-fields__input"
                              [ngClass]="{ '--important': checkUserFormFieldValidation('FirstName')}">
                          </span>
                        </div>
                      </div>
                      <div class="flex-col-sm-6">
                        <!-- <label for="overflowid" class="form-fields__label">LastName<b
                            style="color: red;">*</b></label> -->
                        <div class="single-input-field-wrapper clone-field">
                          <span [attr.data-tooltip]="getFieldError('LastName')" data-tooltip-conf="danger"
                            class="important-input address-input form-fields__input-wrapper"
                            [ngClass]="{ 'hide': !checkUserFormFieldValidation('LastName')}">
                            <input style="padding: 10px 5px 10px 10px;" type="text" formControlName="LastName" id="LastName" name="LastName"
                              placeholder="LastName" size="30" class="form-fields__input"
                              [ngClass]="{ '--important': checkUserFormFieldValidation('LastName')}">
                          </span>
                        </div>
                      </div>
                         <div class="flex-col-sm-6">
                        <!-- <label for="overflowid" class="form-fields__label">Email<b style="color: red;">*</b></label> -->
                        <div class="single-input-field-wrapper clone-field">
                          <span [attr.data-tooltip]="getFieldError('Email')" data-tooltip-conf="danger"
                            class="important-input address-input form-fields__input-wrapper"
                            [ngClass]="{ 'hide': !checkUserFormFieldValidation('Email')}">
                            <input style="padding: 10px 5px 10px 10px;" type="text" formControlName="Email" id="Email" name="Email"
                              placeholder="Email Address" size="30" class="form-fields__input"
                              [ngClass]="{ '--important': checkUserFormFieldValidation('Email')}">
                          </span>
                        </div>
                      </div>

                         <div class="flex-col-sm-6">
                        <!-- <label for="overflowid" class="form-fields__label">Username<b style="color: red;">*</b></label> -->
                        <div class="single-input-field-wrapper clone-field">
                          <span [attr.data-tooltip]="getFieldError('Username')" data-tooltip-conf="danger"
                            class="important-input address-input form-fields__input-wrapper"
                            [ngClass]="{ 'hide': !checkUserFormFieldValidation('Username')}">
                            <input style="padding: 10px 5px 10px 10px;" type="text" formControlName="Username" id="Username" name="Username"
                              placeholder="Username" size="30" class="form-fields__input"
                              [ngClass]="{ '--important': checkUserFormFieldValidation('Username')}">
                          </span>
                        </div>
                      </div>
                      <div class="flex-col-sm-6">
                        <!-- <label for="overflowid" class="form-fields__label">PseudoName<b
                            style="color: red;">*</b></label> -->
                        <div class="single-input-field-wrapper clone-field">
                          <span [attr.data-tooltip]="getFieldError('PseudoName')" data-tooltip-conf="danger"
                            class="important-input address-input form-fields__input-wrapper"
                            [ngClass]="{ 'hide': !checkUserFormFieldValidation('PseudoName')}">
                            <input style="padding: 10px 5px 10px 10px;" type="text" formControlName="PseudoName" id="PseudoName" name="PseudoName"
                              placeholder="PseudoName" size="30" class="form-fields__input"
                              [ngClass]="{ '--important': checkUserFormFieldValidation('PseudoName')}">
                          </span>
                        </div>
                      </div>
                      <div class="flex-col-sm-6">
                        <!-- <label for="overflowid" class="form-fields__label">Ibex ID<b style="color: red;">*</b></label> -->
                        <div class="single-input-field-wrapper clone-field">
                          <span [attr.data-tooltip]="getFieldError('IbexId')" data-tooltip-conf="danger"
                            class="important-input address-input form-fields__input-wrapper"
                            [ngClass]="{ 'hide': !checkUserFormFieldValidation('IbexId')}">
                            <input style="padding: 10px 5px 10px 10px;" type="text" formControlName="IbexId" id="IbexId" name="IbexId"
                              placeholder="Enter 3 to 5 digits ID" size="30" class="form-fields__input"
                              [ngClass]="{ '--important': checkUserFormFieldValidation('IbexId'), 'disabled' : !userService.userCloneModal.inputData.isAgent}">
                          </span>
                        </div> 
                      </div>
                      <div class="flex-col-sm-6">
                        <!-- <label for="overflowid" class="form-fields__label">Phone Number</label> -->
                        <div class="single-input-field-wrapper clone-field">
                          <span [attr.data-tooltip]="getFieldError('PhoneNumber')" data-tooltip-conf="danger"
                            class="important-input address-input form-fields__input-wrapper"
                            [ngClass]="{ 'hide': !checkUserFormFieldValidation('PhoneNumber')}">
                            <input style="padding: 10px 5px 10px 10px;" type="text" formControlName="PhoneNumber" id="PhoneNumber" name="PhoneNumber"
                              placeholder="Phone Number" size="30" class="form-fields__input"
                              [ngClass]="{ '--important': checkUserFormFieldValidation('PhoneNumber')}">
                          </span>
                        </div>
                      </div>
                      <!-- <div class="flex-col-sm-6">
                        <label for="overflowid" class="form-fields__label">Ibex Password<b
                            style="color: red;">*</b></label>
                        <div class="single-input-field-wrapper clone-field">
                          <span [attr.data-tooltip]="getFieldError('Password')" data-tooltip-conf="danger"
                            class="important-input address-input form-fields__input-wrapper"
                            [ngClass]="{ 'hide': !checkUserFormFieldValidation('Password')}">
                            <input style="padding: 10px 5px 10px 10px;" type="password" formControlName="Password" id="Password" name="Password"
                              placeholder="Password" size="30" class="form-fields__input"
                              [ngClass]="{ '--important': checkUserFormFieldValidation('Password'), 'disabled' : !userService.userCloneModal.inputData.isAgent}">
                          </span>
                        </div>
                      </div> -->
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </section>
          <section class="section">
            <div class="section__content">
              <div class="flex-row flex-row--no-pad">
                <div class="flex-col-sm-12">
                  <div class="form-secondary-header">
                    <div class="form-actions">
                      <a (click)="closeModal()" class="single-button--without-bg" style="margin-right: 10px;">Cancel</a>
                      <a (click)="cloneUser()" class="single-button--with-bg">Clone</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>

  </div>
</aside>